import { oaKey } from "@/hooks/planning/oa/useOA";

export function patchOAListCacheAfterPriceSave(queryClient, oaId, listResponse) {
	const updatedRow = (listResponse?.data || []).find((row) => Number(row.id) === Number(oaId));
	if (!updatedRow) {
		return;
	}

	queryClient.setQueriesData(oaKey, (oldData) => {
		if (!oldData?.data) {
			return oldData;
		}

		const hasTargetRow = oldData.data.some((row) => Number(row.id) === Number(oaId));
		if (!hasTargetRow) {
			return oldData;
		}

		return {
			...oldData,
			data: oldData.data.map((row) => (Number(row.id) === Number(oaId) ? updatedRow : row)),
		};
	});
}
